// Kiosk forms (bible 4.14): presentation hook only. Marks a field .is-touched once the visitor has left it, and
// marks every invalid field when a submit is attempted, so CSS can show the error border on engines without
// :user-invalid (older iPad Safari). It never prevents anything: the native validation bubble shows exactly as before.
(function () {
    const SELECTOR = '.ed-kiosk .ed-field__input, .ed-kiosk .ed-kcheck__input';
    const mark = (el) => { if (el && el.matches && el.matches(SELECTOR)) el.classList.add('is-touched'); };

    document.addEventListener('focusout', (e) => mark(e.target));
    document.addEventListener('change', (e) => mark(e.target));
    // iOS does not blur a field when the visitor taps blank space (the keyboard just stays), so a tap on anything
    // other than the focused field counts as leaving it.
    document.addEventListener('pointerdown', (e) => {
        const active = document.activeElement;
        if (active && active !== e.target && !active.contains(e.target)) mark(active);
    }, true);
    // 'invalid' does not bubble: capture it. Fires for each invalid control on a submit attempt.
    document.addEventListener('invalid', (e) => mark(e.target), true);
})();
